import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotoDirective } from './photo.directive';
import { WhatisthisTooltipDirective } from './whatisthis-tooltip.directive';
import { CurrencyMaskDirective } from './currencymask.directive';
import { DigitDecimalNumberDirective } from './digitDecimalNumber.directive';
import { ProductPhotoDirective } from './product-photo.directive';



@NgModule({
  declarations: [PhotoDirective, WhatisthisTooltipDirective, CurrencyMaskDirective, DigitDecimalNumberDirective, ProductPhotoDirective],
  exports: [
    PhotoDirective,
    ProductPhotoDirective,
    WhatisthisTooltipDirective,
    CurrencyMaskDirective,
    DigitDecimalNumberDirective
  ],
  imports: [
    CommonModule
  ]
})
export class DirectiveModule { }
